// extracted by mini-css-extract-plugin
export default {"title":"Menus-module__title___1mLzs","rule":"Menus-module__rule___9DgDJ"};